import {
  inferCommentedByType,
  roleTierLabelFromAccount,
} from './accountRoleClassification';

/**
 * `commented_by_type` for POST /api/complaint_comments.
 * Prefer explicit field from GET /api/accounts/:id; otherwise infer from `role_name`.
 */
export function commentedByTypeFromAccountPayload(payload) {
  const account =
    payload?.data != null && typeof payload.data === 'object' ? payload.data : payload;
  if (!account || typeof account !== 'object') return '';

  const explicit = account.commented_by_type ?? account.commentedByType;
  if (explicit != null && String(explicit).trim() !== '') return String(explicit).trim();

  return inferCommentedByType({
    roleName: roleTierLabelFromAccount(account),
  });
}
